module.exports = __webpack_public_path__ + "static/media/logo-gold.a803e9f3.svg";